import Vue from 'vue'
import Vuex from 'vuex'
import { isArrayEmpty, generateCombinations } from '@/utils/utils'
import { CT_PICK_3, CT_LOTTO_545, INSTANT_SLUG_GAME } from '@/constants/lotto'
import { APK_VERSION_NAME_MAP } from '@/constants/app-version-map'

Vue.use(Vuex)

const isStrEmpty = (str: string): boolean => {
    return !str || str.length === 0 || str === 'undefined'
}

const getUserInfo = () => {
    return localStorage.getItem('user_info') || ''
}

const APK_VERSION_NUMBER_KEY = 'apk_version_number'

const getInitialApkVersionNumber = (): string | null => {
    return localStorage.getItem(APK_VERSION_NUMBER_KEY) || null
}

export default new Vuex.Store({
    state: {
        userInfo: !isStrEmpty(getUserInfo()) ? JSON.parse(getUserInfo()) : null,
        tokenV3: localStorage.getItem('access_tokenv3'),
        cart: [],
        cartRender: [],
        quantity: 0,
        transact459: [],
        transact545: [],
        transactPariLotto: [],
        transactInstantLotto: [],
        transact: [],
        transactPick3: [],
        enabled_game_slugs: '',
        reprintCountToShowCancel: 1,
        showCancelationInPos: false,
        milisecondsToForceFinishPrinting: 2000,
        printSimulateMode: 'always-error',
        autoCancelUnprintedCountdownSeconds: 60,
        usersBypassPrintingCheck: '',
        usersSimulatePrintError: '',
        maxAutoReprintAttempts: 1,
        usersNewReprintDialog: '',
        networkTimeoutSeconds: 30,
        isShowSports: true,
        isOnlyPayment: true,
        isShow645: true,
        isShow590: true,
        isShow459: true,
        isShow545: true,
        isShowPick3: true,
        isShowInstantLotto: true,
        isShowVoucher: true,
        isShowExtra7Boost: false,
        isShowExtra7Bonus: false,
        isLoadingAddCart: false,
        totalCart: 0,
        dataGamesPari: [],
        stepCart: 1,
        apkVersionNumber: getInitialApkVersionNumber(),
        // Extra 7 Boost — active FreeBet redemption context. When set, the next
        // Loto 5/90 Boost purchase is placed as a freebet (no cashier charge) and
        // the coupon is redeemed on success. Null = normal play (no behaviour change).
        freebetContext: !isStrEmpty(localStorage.getItem('freebet_context') || '')
            ? JSON.parse(localStorage.getItem('freebet_context') as string)
            : null,
    },
    getters: {
        mappedAppVersionName: (state) => {
            if (!state.apkVersionNumber) return null
            return APK_VERSION_NAME_MAP[state.apkVersionNumber] ?? state.apkVersionNumber
        },
    },
    mutations: {
        SET_USER_INFO(state, data) {
            state.userInfo = data
        },

        REMOVE_USER_INFO(state) {
            state.userInfo = null
            localStorage.removeItem('user_info')
        },

        SET_TOKEN_V3(state, data) {
            state.tokenV3 = data
        },

        SET_FREEBET_CONTEXT(state, data) {
            state.freebetContext = data
            if (data) {
                localStorage.setItem('freebet_context', JSON.stringify(data))
            } else {
                localStorage.removeItem('freebet_context')
            }
        },

        CLEAR_FREEBET_CONTEXT(state) {
            state.freebetContext = null
            localStorage.removeItem('freebet_context')
        },

        SET_APK_VERSION_NUMBER(state, data) {
            state.apkVersionNumber = data || null
            if (data) {
                localStorage.setItem(APK_VERSION_NUMBER_KEY, data)
            } else {
                localStorage.removeItem(APK_VERSION_NUMBER_KEY)
            }
        },

        SET_DATA_CART(state, data) {
            state.cart = data.cart
            state.cartRender = data.cartRender
            state.quantity = data.quantity
            state.transact = data.transact
            state.totalCart = data.totalCart
            state.transactPariLotto = data.transactPariLotto
            state.transact459 = data.transact459
            state.transact545 = data.transact545
            state.transactPick3 = data.transactPick3

            localStorage.setItem('transactPariLotto', JSON.stringify(data.transactPariLotto))
            localStorage.setItem('transact459', JSON.stringify(data.transact459))
            localStorage.setItem('transact545', JSON.stringify(data.transact545))
            localStorage.setItem(CT_PICK_3.LOCAL_STORAGE_KEY_CART, JSON.stringify(data.transactPick3))
            localStorage.setItem('cartRender', JSON.stringify(data.cartRender ? data.cartRender : []))
            localStorage.setItem('cart', JSON.stringify(data.cart))
            localStorage.setItem('quantity', data.quantity)
            localStorage.setItem('transact', JSON.stringify(data.transact))
            localStorage.setItem('totalCart', JSON.stringify(data.totalCart))
            state.isLoadingAddCart = false
        },

        SET_DATA_CART_NOT_EVENT(state, data) {
            state.transactInstantLotto = data.transactInstantLotto
            state.quantity = data.quantity
            state.totalCart = data.totalCart
            state.cartRender = data.cartRender
            state.cart = data.cart

            localStorage.setItem('cartRender', JSON.stringify(data.cartRender ? data.cartRender : []))
            localStorage.setItem('transactInstantLotto', JSON.stringify(data.transactInstantLotto))
            localStorage.setItem('cart', JSON.stringify(data.cart))
            localStorage.setItem('quantity', data.quantity)
            localStorage.setItem('totalCart', JSON.stringify(data.totalCart))
        },

        SET_DATA_CART_SWITCH(state, data) {
            state.totalCart = data.totalCart
            state.cartRender = data.cartRender
            state.stepCart = data.step
            localStorage.setItem('totalCart', JSON.stringify(data.totalCart))
            localStorage.setItem('cartRender', JSON.stringify(data.cartRender))
            localStorage.setItem('stepCart', JSON.stringify(data.step))
        },
    },
    actions: {
        handleUserInfo({ commit, state }, data) {
            commit('SET_USER_INFO', data)
        },

        removeUserInfo({ commit }) {
            commit('REMOVE_USER_INFO')
        },

        setTokenV3({ commit, state }, data) {
            commit('SET_TOKEN_V3', data)
        },

        onSwitchBetslip({ commit, state }, payload) {
            const { step } = payload
            const cart: any = state.cart
            let type = 'Loto 4/59'

            if (step === 1) {
                type = 'loto-590'
            } else if (step === 2) {
                type = 'lotto-6-45'
            } else if (step === 3) {
                type = 'loto-4-59'
            } else if (step === 4) {
                type = CT_LOTTO_545.SLUG
            } else if (step === CT_PICK_3.STEP_CART) {
                type = CT_PICK_3.SLUG_GAME
            } else {
                type = INSTANT_SLUG_GAME
            }

            const cartRender = cart.filter((x) => x.gameType === type)
            const totalCart = cartRender.reduce((a, b) => a + b.price, 0)
            const param = {
                totalCart,
                cartRender,
                step,
            }

            commit('SET_DATA_CART_SWITCH', param)
        },

        onAddToCartLottoNotEvent({ commit, state }, payload) {
            const transactInstantLotto: any = state.transactInstantLotto
            const cart: any = state.cart
            let quantity: number = state.quantity
            const payloadTransact = { ...payload, wager: payload.price }

            delete payloadTransact['gameType']
            delete payloadTransact['price']
            delete payloadTransact['date']
            transactInstantLotto.push(payloadTransact)

            cart.push(payload)

            const cartRender = transactInstantLotto

            quantity += 1

            const totalCart = cartRender.reduce((a, b) => a + b.price, 0)
            const param = {
                transactInstantLotto,
                quantity,
                cartRender,
                totalCart,
                cart,
            }

            commit('SET_DATA_CART_NOT_EVENT', param)
        },

        onAddToCart({ commit, state }, payload) {
            const pariMutuelLotto = ['loto-4-59', 'lotto-6-45', CT_LOTTO_545.SLUG]

            const cart: any = state.cart
            let cartRender: any = []
            const transact: any = state.transact
            const transactPariLotto: any = state.transactPariLotto
            const transact459: any = state.transact459
            const transact545: any = state.transact545
            const transactPick3: any = state.transactPick3

            let quantity: number = state.quantity
            let totalCart = 0
            let title = `${payload.title}`
            let game = `${payload.game}`
            let quantityBets = 1

            if (!pariMutuelLotto.includes(payload.gameType) && payload.gameNumber) {
                title += ` ${payload.gameNumber}`
                game += `${payload.gameNumber}`
            }

            const selection = payload.gameType !== CT_PICK_3.SLUG_GAME ? payload.selection.sort((a, b) => a - b) : payload.selection
            payload.event_id.map((eventId, i) => {
                const item = {
                    id: new Date()
                        .getTime()
                        .toString(36)
                        .concat(performance.now().toString(), Math.random().toString())
                        .replace(/\./g, ''),
                    parentId: payload.id,
                    eventId,
                    eventDate: payload.eventInfo[i].date,
                    eventName: payload.eventInfo[i].name,
                    selection: [selection],
                    title,
                    price: payload.wager,
                    bets: 0,
                    gameType: payload.gameType,
                    isPariMutuelLotto: payload?.isPariMutuelLotto,
                    marketOption: '',
                    market_name: payload?.market?.market_name || '',
                }
                if (payload.boost) {
                    item['boost'] = true
                }
                if (payload.free_bet) {
                    item['free_bet'] = true
                }

                if (payload.isPariMutuelLotto && payload.selection.length > payload.numberQp) {
                    quantityBets = generateCombinations(Number(payload.selection.length), Number(payload.numberQp))
                    item['price'] = payload.wager * quantityBets
                    item['bets'] = quantityBets
                }

                if (payload.gameType === 'loto-4-59') item['isPariMutuelLotto'] = false

                switch (payload.selectedBetOption ?? '') {
                    case 'both':
                        cart.push(item)
                        const i = { ...item }
                        i.marketOption = 'double_chance'
                        i.id = new Date()
                        .getTime()
                        .toString(36)
                        .concat(performance.now().toString(), Math.random().toString())
                        .replace(/\./g, ''),
                        cart.push(i)
                        break;
                    case 'double_chance':
                        item.marketOption = 'double_chance'
                        cart.push(item)
                        break;
                    default:
                        cart.push(item)
                    break;
                }
                // Boost + Ticket Bonus together. Boost is a flag on the base line, so the
                // line pushed above is the BOOSTED bet — there is no standard Extra 7
                // ticket for the Bonus to attach to. Add one at the standard stake, so the
                // draw ends up with three bets: boosted, standard, bonus.
                if (payload.boost && payload.is_bonus_ticket) {
                    const standardItem = {
                        ...item,
                        id: new Date().getTime().toString(36).concat(performance.now().toString(), Math.random().toString()).replace(/\./g, ''),
                        marketOption: '',
                        price: payload.base_wager || 2000,
                        bets: 0,
                    }
                    delete standardItem['boost']
                    cart.push(standardItem)
                }
                // Ticket Bonus — a second, independent cart line (same numbers/draw,
                // 1,000 GNF, flagged). Normal-market only, so it never carries a
                // double-chance option. Shown as a separate "(Bonus)" row in the cart.
                if (payload.is_bonus_ticket) {
                    const bonusItem = {
                        ...item,
                        id: new Date().getTime().toString(36).concat(performance.now().toString(), Math.random().toString()).replace(/\./g, ''),
                        marketOption: '',
                        price: payload.bonus_wager || 1000,
                        bets: 0,
                        is_bonus_ticket: true,
                    }
                    delete bonusItem['boost']
                    cart.push(bonusItem)
                }
            })

            const item = {
                id: payload.id,
                selection: [payload.selection],
                draws: payload.draws,
                event_id: payload.event_id,
                wager: payload.wager,
                game,
                market_option: '',
            }
            // GUI01-813 — pack pairing key. Both legs of a pack carry the same pack_ref; the
            // lottery combines it with the event it assigns per draw to identify each pack, then
            // resolves it to a real PACK_ID. When boost is on, `item` IS the boosted bet — that bet
            // is not part of the pack, so the standard leg synthesised further down carries the ref
            // instead.
            if (payload.is_bonus_ticket && !payload.boost) {
                item['pack_ref'] = payload.id
            }
            if (payload.boost) {
                item['boost'] = true
            }
            // FreeBet marker travels with the cart item so the ticket stays a freebet
            // through checkout (independent of the transient freebet context).
            if (payload.free_bet) {
                item['free_bet'] = true
                item['freebet_code'] = payload.freebet_code
                item['freebet_total'] = payload.freebet_total
            }

            if (payload.gameType === 'lotto-6-45') {
                transactPariLotto.push(item)
            } else if (payload.gameType === 'loto-4-59') {
                transact459.push(item)
            } else if (payload.gameType === CT_LOTTO_545.SLUG) {
                transact545.push(item)
            } else if (payload.gameType === CT_PICK_3.SLUG_GAME) {
                item['market'] = payload?.market?.market_slug || ''
                transactPick3.push(item)
            } else {
                switch (payload.selectedBetOption ?? '') {
                    case 'both':
                        transact.push(item)
                        const i = { ...item }
                        i.market_option = 'double_chance'
                        transact.push(i)
                        break;
                    case 'double_chance':
                        item.market_option = 'double_chance'
                        transact.push(item)
                        break;
                    default:
                        transact.push(item)
                    break;
                }
            }

            // Boost + Ticket Bonus: mirror of the cart split above. The entry pushed
            // earlier carries the boost flag, so send an unflagged standard entry at the
            // standard stake for the Bonus to pair with.
            if (payload.boost && payload.is_bonus_ticket) {
                const standardEntry = {
                    ...item,
                    wager: payload.base_wager || 2000,
                    market_option: '',
                }
                delete standardEntry['boost']
                standardEntry['pack_ref'] = payload.id
                transact.push(standardEntry)
            }
            // Ticket Bonus — send a second transact entry (same numbers/draw, flagged,
            // 1,000 GNF). The wallet routes ONLY this flagged entry to the bonus game;
            // the unflagged standard entry above stays the standard Extra 7 ticket.
            // Both share one transaction / external_id (the pack link).
            if (payload.is_bonus_ticket) {
                const bonusEntry = {
                    ...item,
                    wager: payload.bonus_wager || 1000,
                    market_option: '',
                    is_bonus_ticket: true,
                }
                delete bonusEntry['boost']
                bonusEntry['pack_ref'] = payload.id
                transact.push(bonusEntry)
            }

            cartRender = cart.filter((x) => x.gameType)
            totalCart = cartRender.reduce((a, b) => a + b.price, 0)
            quantity = cart.length

            const param = {
                quantity,
                transact,
                cart,
                totalCart,
                transactPariLotto,
                transact459,
                transact545,
                transactPick3,
                cartRender,
            }

            commit('SET_DATA_CART', param)
        },

        onRemoveItemCart({ commit, state }, payload) {
            const element = payload.item

            // Extra 7 Ticket Bonus pairing (loto-590 packs). All lines of one draw share
            // parentId + eventId; the transact entries share id === parentId and differ by
            // their boost / is_bonus_ticket flags. A draw can hold up to three bets:
            // boosted, standard, bonus.
            //  - Removing the STANDARD line removes its Bonus line too — a bonus can't
            //    stand alone (would leave a lone 1,000 GNF ticket to abuse).
            //  - Removing the Bonus line leaves the other bets in the cart.
            //  - Removing the BOOST line touches nothing else: it is its own bet, and the
            //    Bonus is attached to the standard ticket, not to it.
            // Handled here as a self-contained branch; the standard (non-bonus) removal
            // logic below is left unchanged.
            const cartState: any = state.cart
            const isBonusLine = !!element.is_bonus_ticket
            const isBoostLine = !!element.boost
            // A pack is one draw's standard line plus its Bonus line, keyed on
            // parentId + eventId. Tapping either half removes the whole pack — it is sold
            // and paid as one unit, so half a pack must never survive in the betslip.
            const isSamePack = (x) => x.parentId === element.parentId && x.eventId === element.eventId
            const isPackLine =
                !isBoostLine &&
                (isBonusLine || cartState.some((x) => isSamePack(x) && !!x.is_bonus_ticket))
            if (isPackLine) {
                // Drop both halves of THIS pack only. Other packs differ by eventId (several
                // draws in one add-to-cart) or by parentId (several add-to-cart rounds), so
                // they are untouched. A Boost bet on the same draw is its own bet and stays.
                const nextCart: any = cartState.filter((x) => !(isSamePack(x) && !x.boost))
                const nextTransact: any = state.transact
                // Trim this event from the pack's two entries. Entries span every draw of
                // one add-to-cart, so only this eventId comes out; an entry left with no
                // draws is dropped. The boosted entry is never touched here.
                for (let i = nextTransact.length - 1; i >= 0; i--) {
                    const t = nextTransact[i]
                    if (t.id !== element.parentId) continue
                    if (t.boost) continue
                    t.event_id = t.event_id.filter((e) => e !== element.eventId)
                    if (isArrayEmpty(t.event_id)) {
                        nextTransact.splice(i, 1)
                    }
                }
                const nextCartRender = nextCart.filter((x) => x.gameType === element.gameType)
                commit('SET_DATA_CART', {
                    quantity: nextCart.length,
                    transact: nextTransact,
                    cart: nextCart,
                    totalCart: nextCartRender.reduce((a, b) => a + b.price, 0),
                    transactPariLotto: state.transactPariLotto,
                    transact459: state.transact459,
                    transact545: state.transact545,
                    transactPick3: state.transactPick3,
                    cartRender: nextCartRender,
                })
                return
            }

            const cart: any = state.cart
            let cartRender: any = []
            const transact: any = state.transact
            const transactPariLotto: any = state.transactPariLotto
            const transact459: any = state.transact459
            const transact545: any = state.transact545
            const transactPick3: any = state.transactPick3
            let quantity: number = state.quantity
            let totalCart: number = state.totalCart

            let transactClone: any = []

            if (element.gameType === 'lotto-6-45') {
                transactClone = transactPariLotto
            } else if (element.gameType === 'loto-4-59') {
                transactClone = transact459
            } else if (element.gameType === CT_LOTTO_545.SLUG) {
                transactClone = transact545
            } else if (element.gameType === CT_PICK_3.SLUG_GAME) {
                transactClone = transactPick3
            } else {
                transactClone = transact
            }

            const index = transactClone.findIndex((x) => x.id === element.parentId)

            if (index !== -1) {
                transactClone[index].event_id = transactClone[index].event_id.filter((x) => x !== element.eventId)
            }

            if (isArrayEmpty(transactClone[index]?.event_id)) {
                transactClone.splice(index, 1)
            }

            const indexCart = cart.findIndex((x) => x.id === element.id)

            cart.splice(indexCart, 1)

            cartRender = cart.filter((x) => x.gameType === element.gameType)

            totalCart = cartRender.reduce((a, b) => a + b.price, 0)
            quantity = cart.length
            const param = {
                quantity,
                transact,
                cart,
                totalCart,
                transact459,
                transact545,
                transactPariLotto,
                transactPick3,
                cartRender,
            }

            if (element.gameType === 'lotto-6-45') {
                param['transactPariLotto'] = transactClone
            } else if (element.gameType === 'loto-4-59') {
                param['transact459'] = transactClone
            } else if (element.gameType === CT_LOTTO_545.SLUG) {
                param['transact545'] = transactClone
            } else if (element.gameType === CT_PICK_3.SLUG_GAME) {
                param['transactPick3'] = transactClone
            } else {
                param['transact'] = transactClone
            }

            commit('SET_DATA_CART', param)
        },

        onClearCart({ state, commit }) {
            let cart: any = state.cart

            let type = 'loto-4-59'

            if (state.stepCart === 1) {
                type = 'loto-590'
            } else if (state.stepCart === 2) {
                type = 'lotto-6-45'
            } else if (state.stepCart === 3) {
                type = 'loto-4-59'
            } else if (state.stepCart === 4) {
                type = CT_LOTTO_545.SLUG
            } else if (state.stepCart === CT_PICK_3.STEP_CART) {
                type = CT_PICK_3.SLUG_GAME
            } else {
                type = INSTANT_SLUG_GAME
            }

            cart = cart.filter((x) => x.gameType !== type)
            const totalCart = cart.reduce((a, b) => a + b.price, 0)
            const quantity = cart.length

            const param = {
                quantity,
                transact: state.stepCart === 1 ? [] : state.transact,
                cart: cart,
                cartRender: [],
                totalCart,
                transactPariLotto: state.stepCart === 2 ? [] : state.transactPariLotto,
                transact459: state.stepCart === 3 ? [] : state.transact459,
                transact545: state.stepCart === 4 ? [] : state.transact545,
                transactPick3: state.stepCart === CT_PICK_3.STEP_CART? [] : state.transactPick3,
            }

            if (type === INSTANT_SLUG_GAME) {
                const paramNotEvent = {
                    transactInstantLotto: [],
                    cartRender: [],
                    quantity,
                    totalCart,
                    cart,
                }

                commit('SET_DATA_CART_NOT_EVENT', paramNotEvent)

                return
            }

            commit('SET_DATA_CART', param)
        },

        onClearCartAll({ commit }) {
            const param = {
                quantity: [],
                transact: [],
                cart: [],
                totalCart: 0,
                transactPariLotto: [],
                transact459: [],
                transact545: [],
                transactPick3: [],
                cartRender: [],
            }
            commit('SET_DATA_CART', param)
        },
    },
})
